import button from './zh-CN/button';
import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import message from './zh-CN/message';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import serverMessage from './zh-CN/serverMessage';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...message,
  ...button,
  ...serverMessage,
};
